// utils/authErrors.js
// Zentrale Funktion für Firebase Auth Error Messages in Deutsch

export const getAuthErrorMessage = (error) => {
  if (!error) return null

  // Hole den Error Code aus dem Firebase Error Object
  const errorCode = error.code || error.message || error

  // Firebase Auth Error Codes zu deutschen Fehlermeldungen
  const errorMessages = {
    // Login Errors
    'auth/user-not-found': 'Kein Benutzer mit dieser E-Mail gefunden.',
    'auth/wrong-password': 'Falsches Passwort.',
    'auth/invalid-email': 'Ungültige E-Mail-Adresse.',
    'auth/user-disabled': 'Dieser Account wurde deaktiviert.',
    'auth/too-many-requests': 'Zu viele fehlgeschlagene Versuche. Bitte versuchen Sie es später erneut.',
    'auth/operation-not-allowed': 'Diese Anmelde-Methode ist nicht aktiviert.',
    'auth/invalid-credential': 'Die Anmeldedaten sind ungültig.',
    'auth/invalid-login-credentials': 'E-Mail oder Passwort ist falsch.',

    // Register Errors
    'auth/email-already-in-use': 'Diese E-Mail-Adresse ist bereits registriert.',
    'auth/weak-password': 'Das Passwort ist zu schwach. Verwenden Sie mindestens 6 Zeichen.',
    'auth/password-does-not-meet-requirements': 'Das Passwort erfüllt nicht die Anforderungen.',

    // Network & General Errors
    'auth/network-request-failed': 'Netzwerkfehler. Bitte überprüfen Sie Ihre Internetverbindung.',
    'auth/internal-error': 'Ein interner Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
    'auth/requires-recent-login': 'Diese Aktion erfordert eine erneute Anmeldung.',

    // Token & Session Errors
    'auth/expired-action-code': 'Dieser Link ist abgelaufen.',
    'auth/invalid-action-code': 'Dieser Link ist ungültig.',
    'auth/user-token-expired': 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',

    // Password Reset
    'auth/missing-password': 'Bitte geben Sie ein Passwort ein.',
    'auth/missing-email': 'Bitte geben Sie eine E-Mail-Adresse ein.'
  }

  // Versuche exakte Übereinstimmung
  if (errorMessages[errorCode]) {
    return errorMessages[errorCode]
  }

  // Fallback: Suche nach Teilstring (für Kompatibilität mit älteren Error Formaten)
  for (const [key, message] of Object.entries(errorMessages)) {
    if (errorCode.includes(key.replace('auth/', ''))) {
      return message
    }
  }

  // Generic Fallback
  if (errorCode.includes('login') || errorCode.includes('sign-in')) {
    return 'Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihre Anmeldedaten.'
  }

  if (errorCode.includes('register') || errorCode.includes('sign-up')) {
    return 'Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.'
  }

  // Ultimate Fallback
  return 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.'
}
